const tabs = {
  lotto: ['kenoplustwoball_gt_html', 'keno_universe_html'],
  cardGames: [
    'blackjack_classic_touch',
    'blackjack_single_deck_touch',
    'blackjack_touch',
    'all_american_multiple_hands',
    'blackjack_double_exposure',
    'blackjack_pro',
    'blackjack_single_deck',
    'deuces_wild_poker',
    'deuces_wild_poker_10_hands',
    'joker_wild_multiple_hands',
    'deuces_wild_poker_25_hands',
    'deuces_wild_poker_50_hands',
    'deuces_wild_poker_multiple_hands',
    'jacks_or_better',
    'jacks_or_better_10_hands',
    'jacks_or_better_5_hands',
    'jacks_or_better_multiple_hands',
  ],
  roulette: [
    'roulette_touch',
    'american_roulette',
    'european_roulette',
    'french_roulette',
    'roulette_pro',
    'american_roulette_html',
    'french_roulette_html',
    'rouletteroyal_original',
  ],
  popular: [
    'always_hot_classic_html',
    'bananas_go_bahamas_html',
    'book_of_ra_classic_html',
    'columbus_classic_html',
    'diamond_trio_html',
    'dolphins_pearl_classic_html',
    'gryphons_gold_classic_html',
    'marco_polo_classic_html',
    'french_roulette_html',
    'fruit_case_html',
    'fruit_spin',
    'fruitshop_christmas',
    'ghost_pirates_html',
    'glow_touch',
  ],
  crash: ['rocketman_elbet', 'plinko_stake', 'aviator_spribe', 'jetx_ssg'],
  bingo: ['keno_austria', 'keno_universe_html', 'kenoplustwoball_gt_html'],
  xMas: [
    // Booongo
    'christmas_charm_bng_html',
    'lucky_xmas_bng_html',
    // kajot
    'ice_bar_27_kjt_html',
    // Microgaming
    'hollyjollypenguins_mg_html',
    'santaswildride_mg_html',
    // NetEnt
    'flowers_christmas',
    'fruitshop_christmas',
    'jingle_spin',
    'santa_vs_rudolf',
    'secrets_of_christmas',
    // Playson
    'fruits_n_stars_he_ps_html',
    // Pushgaming
    'fatsanta_pg',
    // Quickspin
    'qso_polarpaws',
  ],
  halloween: [
    'wolf_moon_original', // Wolf Moon (wolf_moon_original)
    'bookoffruitshalloween_original', // Book of Fruits Halloween (bookoffruitshalloween_original)
    'blood_ag', // Blood (blood_ag)
    // Aristocrat
    'werewolf_wild_html', // Werewolf Wild (werewolf_wild_html)
    // Booongo
    'black_wolf_bng_html', // Black Wolf (black_wolf_bng_html)
    // EGT
    'witches_charm_html', // Witches Charm (witches_charm_html)
    // Greentube
    'thirteen_gt_html', // Thirteen (thirteen_gt_html)

    // Microgaming
    'thephantomoftheopera_mg_html', // The Phantom of the Opera (thephantomoftheopera_mg_html)
    'halloween_mg_html', // Halloween (halloween_mg_html)
    'halloweenies_mg_html', // Halloweenies (halloweenies_mg_html)

    // NetEnt
    'phantom_of_the_opera', // Phantom of the Opera (phantom_of_the_opera)
    'frankenstein_touch', // Frankenstein (frankenstein_touch)
    'dracula_touch', // Dracula (dracula_touch)
    'mythic_maiden_touch', // Mythic Maiden (mythic_maiden_touch)
    'the_invisible_man', // The Invisible Man (the_invisible_man)
    'blood_suckers_touch', // Blood Suckers (blood_suckers_touch)
    'blood_suckers_2', // Blood Suckers 2 (blood_suckers_2)
    'dead_or_alive_html', // Dead or Alive (dead_or_alive_html)
    'halloween_jack', // Halloween Jack (halloween_jack)
    'dead_or_alive_2', // Dead or Alive 2 (dead_or_alive_2)
    'witchcraft_academy', // Witchcraft Academy (witchcraft_academy)

    'deadwood_nl', // Deadwood (deadwood_nl)
    'infectious5_nl', // Infectious 5 Ways (infectious5_nl)
    'mental_nl', // Mental (mental_nl)
    'tombstonerip_nl', // Tombstone R.I.P (tombstonerip_nl)

    'wolf_power_ps_html',

    // Playngo
    'happyhalloween_png', // Happy Halloween (happyhalloween_png)
    // WMG (Playtech)
    'hauntedhouserip_wmg', // Haunted House Rest In Paradise (hauntedhouserip_wmg)
    'hauntedhouse_wmg', // Haunted House (hauntedhouse_wmg)
    // Relaxgaming
    'deadmanstrail_rg', // Dead Man's Trail (deadmanstrail_rg)
    'deadriderstrail_rg', // Dead Riders Trail (deadriderstrail_rg)
    // Wazdan
    'hh_wzdn', // Haunted Hospital (hh_wzdn)
  ],
};

function getSlotImage(slotId /* sectionId */) {
  const slotIdStr = slotId.toLowerCase();
  return `https://static.gmnggate.com/thumbnails/235x235/${slotIdStr}.jpg`;
}

function getSections(gameList) {
  const sections = gameList.reduce(
    (types, item) => (types.indexOf(item.sectionId) !== -1 ? types : [...types, item.sectionId]),
    [],
  );
  sections.unshift('all');
  return sections;
}

function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines'],
  );
  return trueTab;
}

export { getSections, getTab, getSlotImage };
